import { styled } from '@mui/system';
export default styled('pre')(({ width = '100%', height = '240px', margin = '10px 0px' }) => ({
    margin,
    height,
    width,
    overflow: 'auto',
}));
